import { HttpBaseService } from "../../Common/services/http-base-service";
declare var APIURL: string;
export function getUserCartInfos(): Promise<number> {
    var quantityInCart = HttpBaseService.get<number>(`${APIURL}/carts/{0}/quantity`);
    return quantityInCart;
}